import gql from "graphql-tag"

export default gql`
  query allAlbums($user: String!, $slug: String!) {
    User: userByUsername(username: $user) {
      id
      tags: albumTags {
        id
        name
      }
    }
    allAlbums: albums(
      filter: {
        user: { username: { equalTo: $user } }
        hidden: { equalTo: false }
        slug: { equalTo: $slug }
      }
    ) {
      id
      slug
      title
      description
      keyValues {
        id
        key {
          id
          name
        }
        value
      }
      tags {
        id
        name
      }
      slides(orderBy: POS_ASC, filter: { hidden: { equalTo: false } }) {
        id
        order: pos
        file: image {
          id
          url
          secret
        }
        videoUrl
        width
        height
        title
        description
        slideTags: tags {
          id
          name
        }
        slideKeyValues: keyValues {
          id
          slideKey: key {
            id
            name
          }
          value
        }
      }
    }
  }
`
